import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { PowerPrice } from '../../../../dynamic-power-prices/types'
import PowerPriceChartPrint from './PowerPriceChartPrint'
import PowerPriceChartCsvExport from './PowerPriceChartCsvExport'
import { HIDE_ON_PRINT_CLASS } from 'src/Libs/chart-kit/shared/utils/print-chart-data'
import { POWER_PRICE_CHART_TO_PRINT_ID } from './power-price-chart.constants'

const useStyles = makeStyles()(theme => ({
  wrapper: {
    padding: `${theme.spacing(2)} ${theme.spacing(4)} ${theme.spacing(0)} ${theme.spacing(4)}`,
    display: 'flex',
    flex: '1',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignContent: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0, 2),
    },
  },
  printPosition: {
    position: 'absolute',
    right: 0,
    margin: theme.spacing(4),
  },
  invisible: {
    visibility: 'hidden',
  },
}))

interface Props {
  prices: PowerPrice[]
  lastFetchedTimestamp?: string
  installationId?: string
  storageId?: string
  price?: string
  date?: string
  timeRange?: string
  isLoading?: boolean
}

/**
 * component to create a chart label for the current time
 * @param price
 * @param className
 */
const PowerPriceChartHeader: React.VFC<Props> = ({
  prices,
  lastFetchedTimestamp,
  installationId,
  storageId,
  price,
  date,
  timeRange,
  isLoading = false,
}) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Box className={classes.wrapper}>
      <Box className={isLoading ? classes.invisible : undefined} display={'flex'} flex={1} flexDirection={'column'} alignItems={'center'}>
        <Typography variant="h1" fontSize={28}>
          {price}
        </Typography>
        <Box display="flex" flexDirection="row" gap={2}>
          <Typography variant="body1">{date}</Typography>
          <Typography variant="body1">{timeRange}</Typography>
        </Box>
      </Box>
      <Box className={classes.printPosition}>
        {!isMobile && (
          <Box className={HIDE_ON_PRINT_CLASS}>
            <PowerPriceChartPrint
              title={t('dashboard.liveView.widgets.dynamic-power-price.title')}
              dataFetchTimeStamp={lastFetchedTimestamp || ''}
              printElementId={POWER_PRICE_CHART_TO_PRINT_ID}
              installationId={installationId}
              storageId={storageId}
            />
            <PowerPriceChartCsvExport prices={prices} />
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default PowerPriceChartHeader
